import React from "react";
import cn from "classnames";
import styles from "./half-split-row.module.scss";

interface HalfSplitRowPropTypes {
  children: React.ReactNode;
  alignCenter?: boolean;
  spaceBetween?: boolean;
}

const cssClassName = "half-split-row";

export const HalfSplitRow = ({
  children,
  alignCenter,
  spaceBetween,
}: HalfSplitRowPropTypes) => {
  const childArray = React.Children.toArray(children);
  const midpoint = Math.ceil(childArray.length / 2);

  const firstHalfChildren = childArray.slice(0, midpoint);
  const secondHalfChildren = childArray.slice(midpoint);

  return (
    <div
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--align-center`]]: alignCenter,
        [styles[`${cssClassName}--space-between`]]: spaceBetween,
      })}
    >
      <div className={styles[`${cssClassName}__first-group`]}>
        {firstHalfChildren}
      </div>
      <div className={styles[`${cssClassName}__second-group`]}>
        {secondHalfChildren}
      </div>
    </div>
  );
};
